import classNames from 'classnames';
import { LogoDarkIcon } from 'icons';
import styles from '../style.module.scss';

const COPYRIGHT_YEAR_START = 2015;
const COMPANY_NAME = 'Arcusworld Real Estate s.r.l.';

/**
 * Page footer with logo and copyright.
 */
export function VacanciesFooter() {
  const year = new Date().getFullYear();
  const yearRange =
    year === COPYRIGHT_YEAR_START
      ? String(year)
      : `${COPYRIGHT_YEAR_START}-${year}`;

  return (
    <footer
      className={classNames(
        styles.containerFluid,
        styles.textCenter,
        styles.footer,
      )}
    >
      <LogoDarkIcon height='120px' width='auto' />
      <p>
        © Copyright {yearRange} - {COMPANY_NAME}
      </p>
    </footer>
  );
}
